import { Component, OnInit } from '@angular/core'
import { BreadcrumbService } from 'src/app/shared/services/breadcrumb.service'
import { Country } from '../../../shared/interfaces/resources/country.interface'
import { CountryService } from '../../../shared/services/country.service'
import { MetaService } from '../../../shared/services/meta.service'
import { CountryGroup } from '../../../shared/interfaces/resources/country-group.inerface'

@Component({
  selector: 'app-country-list',
  templateUrl: './country-list.component.html',
  styleUrls: ['./country-list.component.scss']
})
export class CountryListComponent implements OnInit {
  countries: Country[]
  countryGroups: CountryGroup[]

  constructor(
    private countryService: CountryService,
    private breadcrumbService: BreadcrumbService,
    private metaService: MetaService
  ) {}

  ngOnInit(): void {
    this.countryService.list().then((countriesRes: Country[]) => {
      this.countries = countriesRes

      this.countryGroups =
        this.countryService.groupCountries(this.countries);
    })

    this.breadcrumbService.breadcrumbLinks.next([{ label: 'Countries' }])
    this.metaService.setTags('countries')
  }
}
